export default "__VITE_PUBLIC_ASSET__39a98383__"